import React from 'react';

import { Text, VStack } from '@fhs-legacy/universal-components';
import {
  ILinkWidgetFragment,
  IVerticalLinkListWithHeaderWidgetFragment,
} from 'generated/sanity-graphql';

import { Links } from './links';

type IVerticalLinkListWithHeaderProps = IVerticalLinkListWithHeaderWidgetFragment;

export const VerticalLinkListWithHeader: React.FC<IVerticalLinkListWithHeaderProps> = props => {
  return (
    <VStack mb="$6">
      <Text
        variant="copyTwo"
        color="token.text-reversed"
        fontFamily="heading"
        fontSize={18}
        lineHeight={24}
        fontWeight="700"
        mb="$3"
        accessibilityRole="text"
      >
        {props.header?.locale}
      </Text>
      <Links links={props.linkWidgets as ILinkWidgetFragment[]} />
    </VStack>
  );
};
